﻿
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { PublicComponent } from './public.component';

export const publicRoutes: Routes = [
    {
        path: 'public', component: PublicComponent,
        children: [
            { path: '', redirectTo: 'login', pathMatch: 'full', },
            { path: 'login', component: LoginComponent }
        ]
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(publicRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class PublicRoutingModule { }
